// SLY · Header: menu labels are links; the chevron beside a label opens its mega panel (hover with a mouse, click/tap/keyboard otherwise); phone menu drawer.
document.querySelectorAll('[data-sly-nav]').forEach(nav => {
  const scrim = nav.querySelector('.sly-mm__scrim');
  const btns = [...nav.querySelectorAll('.sly-nav__drop[aria-controls]')];
  let open = null, timer;
  const show = id => {
    clearTimeout(timer);
    if (open === id) return;
    nav.querySelectorAll('.sly-mm').forEach(p => p.hidden = p.id !== id);
    btns.forEach(b => b.setAttribute('aria-expanded', b.getAttribute('aria-controls') === id));
    scrim.hidden = id === null; open = id;
  };
  const hide = () => show(null);
  const hover = matchMedia('(hover: hover)');
  btns.forEach(b => {
    const id = b.getAttribute('aria-controls');
    b.addEventListener('click', () => open === id ? hide() : show(id));
    b.addEventListener('mouseenter', () => { if (hover.matches) timer = setTimeout(() => show(id), open === null ? 120 : 0); });
  });
  nav.querySelectorAll('a.sly-nav__t').forEach(a => a.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(hide, 120); }));
  nav.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(hide, 180); });
  nav.addEventListener('mouseenter', () => { if (open !== null) clearTimeout(timer); });
  scrim.addEventListener('click', hide);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && open !== null) { const b = nav.querySelector(`[aria-controls="${open}"]`); hide(); b && b.focus(); } });
  nav.addEventListener('focusout', e => { if (!nav.contains(e.relatedTarget)) hide(); });

  const drawer = nav.querySelector('[data-sly-drawer]');
  nav.querySelector('[data-sly-burger]').addEventListener('click', () => drawer.showModal());
  drawer.addEventListener('click', e => { if (e.target === drawer || e.target.closest('[data-sly-drawer-close]') || e.target.closest('a')) drawer.close(); });
});

// search modal: popular searches + products before typing, Shopify predictive search while typing
document.querySelectorAll('[data-sly-search]').forEach(dlg => {
  const input = dlg.querySelector('[data-sly-search-input]'), box = dlg.querySelector('[data-sly-search-results]');
  const idle = box.innerHTML, esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const cur = (document.querySelector('[data-sly-cart-config]') && JSON.parse(document.querySelector('[data-sly-cart-config]').textContent)) || { currency: '', decimals: 2 };
  const price = p => `${cur.currency} ${Number(p).toFixed(cur.decimals)}`;
  let timer, ctrl;
  document.querySelectorAll('[data-sly-search-open]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); dlg.showModal(); input.focus(); }));
  dlg.addEventListener('click', e => { if (e.target === dlg || e.target.closest('[data-sly-search-close]')) dlg.close(); });
  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (!q) { box.innerHTML = idle; return; }
    timer = setTimeout(async () => {
      ctrl && ctrl.abort(); ctrl = new AbortController();
      const url = `${dlg.dataset.suggest}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last`;
      let r;
      try { r = (await fetch(url, { signal: ctrl.signal }).then(x => x.json())).resources.results; } catch (err) { return; }
      const all = `${dlg.dataset.search}?q=${encodeURIComponent(q)}&options[prefix]=last`;
      const prods = r.products || [], cols = r.collections || [], qs = r.queries || [];
      box.innerHTML = !prods.length && !cols.length
        ? `<p class="sly-search__empty">Nothing found for “${esc(q)}”. Try a shorter word, like “brush” or “cherry”.</p>`
        : `${qs.length ? `<div class="sly-search__chips">${qs.slice(0, 5).map(x => `<a href="${esc(x.url)}">${x.styled_text}</a>`).join('')}</div>` : ''}
           ${cols.length ? `<h3>Collections</h3><div class="sly-search__chips">${cols.map(c => `<a href="${esc(c.url)}">${esc(c.title)}</a>`).join('')}</div>` : ''}
           ${prods.length ? `<h3>Products</h3><div class="sly-search__grid">${prods.map(p => `<a class="sly-mm__card" href="${esc(p.url)}"><span class="sly-mm__pic">${p.image ? `<img src="${esc(p.image)}${p.image.includes('?') ? '&' : '?'}width=400" alt="" loading="lazy">` : ''}</span><b>${esc(p.title)}</b><span>${price(p.price)}</span></a>`).join('')}</div>` : ''}
           <a class="sly-search__all" href="${all}">See all results for “${esc(q)}”</a>`;
    }, 180);
  });
});

// phones: hide the sticky header while scrolling down, show it again on the way up
(() => {
  const wrap = document.querySelector('.sly-nav--sticky')?.parentElement; if (!wrap) return;
  let last = scrollY;
  addEventListener('scroll', () => {
    const y = scrollY, menuOpen = document.querySelector('.sly-mm:not([hidden])');
    if (Math.abs(y - last) < 6) return;
    wrap.classList.toggle('sly-nav-away', y > last && y > wrap.offsetHeight * 2 && !menuOpen);
    last = y;
  }, { passive: true });
})();
